import '../application';

$('#facebook-share').on('click', function (e) {
  shareWindow(this, 'facebook');
  e.preventDefault();
});

$('#twitter-share').on('click', function (e) {
  shareWindow(this, 'twitter');
  e.preventDefault();
});

function shareWindow (el, title, width = 675, height = 500) {
  const left = ($(window).width() - width) / 2;
  const top = ($(window).height() - height) / 2;
  const url = el.href;
  const opts = `width=${width
  },height=${height
  },top=${top
  },left=${left}`;

  window.open(url, title, opts);
}
